<svg
  width="33"
  height="34"
  viewBox="0 0 33 34"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_3_305)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.25 17C31.25 25.1462 24.6462 31.75 16.5 31.75C8.3538 31.75 1.75 25.1462 1.75 17C1.75 8.8538 8.3538 2.25 16.5 2.25C24.6462 2.25 31.25 8.8538 31.25 17ZM16.5 33.5C25.6127 33.5 33 26.1127 33 17C33 7.8873 25.6127 0.5 16.5 0.5C7.3873 0.5 0 7.8873 0 17C0 26.1127 7.3873 33.5 16.5 33.5ZM16.5 27.75C22.4371 27.75 27.25 22.9371 27.25 17C27.25 11.0629 22.4371 6.25 16.5 6.25C10.5629 6.25 5.75 11.0629 5.75 17C5.75 22.9371 10.5629 27.75 16.5 27.75ZM29 17C29 23.9036 23.4036 29.5 16.5 29.5C9.59644 29.5 4 23.9036 4 17C4 10.0964 9.59644 4.5 16.5 4.5C23.4036 4.5 29 10.0964 29 17Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_3_305">
      <rect width="33" height="33" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
